import { Box, Stack, Text } from "@chakra-ui/react";
import { FC } from "react";
import { MdCancel, MdCheckCircle } from "react-icons/md";

type SamedayPickupMessageCardProps = {
  isSamedayEligible: boolean;
  distance: string;
  canPickupToday: boolean;
};

export const SamedayPickupMessageCard: FC<SamedayPickupMessageCardProps> = ({
  isSamedayEligible,
  distance,
  canPickupToday,
}) => {
  const distanceMessages = [
    {
      message: "Located within approximately 5km",
      validate: (locationDistance: number) => locationDistance <= 5,
    },
    {
      message: "Located within approximately 10km",
      validate: (locationDistance: number) =>
        locationDistance > 5 && locationDistance <= 10,
    },
    {
      message: `Located within approximately 15km`,
      validate: (locationDistance: number) =>
        locationDistance > 10 && locationDistance <= 15,
    },
    {
      message: `Located within approximately 20km`,
      validate: (locationDistance: number) =>
        locationDistance > 15 && locationDistance <= 20,
    },
    {
      message: `Located within approximately 25km`,
      validate: (locationDistance: number) =>
        locationDistance > 20 && locationDistance <= 25,
    },
  ];

  return (
    <Box
      alignItems="center"
      border="1px solid lightgray"
      borderRadius="0.5rem"
      boxShadow="base"
      display="flex"
      gap="0.5rem"
      padding="1rem"
    >
      {isSamedayEligible ? (
        <MdCheckCircle color="blue" size={30} />
      ) : (
        <MdCancel color="red" size={30} />
      )}
      <Stack>
        <Text fontWeight="bold" style={{ margin: 0 }}>
          {!isSamedayEligible
            ? "Item can't be picked up"
            : canPickupToday
            ? "This item can be picked up today"
            : "Pickup available tomorrow"}
        </Text>
        <Text fontSize={14} style={{ margin: 0 }}>
          {distanceMessages.find((message) =>
            message.validate(Number(distance))
          )?.message || `Located approximately ${distance}km away`}
        </Text>
      </Stack>
    </Box>
  );
};
